import { useEffect } from 'react';
import { ROUTES } from '../../navigation/routes';
import { verifyAndClearAuth0SessionInitState } from '../../okta/auth0-session-init';
import Loader from '@tcl-boron-prefabs/loader';
import cn from 'classnames';
import logger from '../../utils/logger';
import withStyles from '@tempus/component-library/utils/withStyles';
import styles from '../../styles';

function Auth0SessionCallback({ classes }) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (!verifyAndClearAuth0SessionInitState(params.get('state'))) {
      logger.warn('Auth0 session callback state mismatch; redirecting to root');
      window.location.replace(ROUTES.ROOT);
      return;
    }
    window.location.replace(ROUTES.APP_SWITCHER);
  }, []);

  return (
    <div className={cn('app-view-container', classes.loadingContainer)} data-testid="auth0-session-callback-loading">
      <Loader />
    </div>
  );
}

export default withStyles(styles)(Auth0SessionCallback);
